var rawPipe = function rawPipe() {
  var res;

  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  while (fns.length) {
    res = fns.shift()(res);
  }

  return res;
};

var isIterable = function isIterable(obj) {
  return obj && (typeof obj[Symbol.asyncIterator] === 'function' || typeof obj[Symbol.iterator] === 'function' || typeof obj.next === 'function' // Probably, right?
  );
};

var isDuplex = function isDuplex(obj) {
  return obj && typeof obj.sink === 'function' && isIterable(obj.source);
};

var duplexPipelineFn = function duplexPipelineFn(duplex) {
  return function (source) {
    duplex.sink(source); // TODO: error on sink side is unhandled rejection - this is the same as pull streams

    return duplex.source;
  };
};

var pipe = function pipe() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  // Duplex at start: wrap in function and return duplex source
  if (isDuplex(fns[0])) {
    var duplex = fns[0];

    fns[0] = function () {
      return duplex.source;
    }; // Iterable at start: wrap in function

  } else if (isIterable(fns[0])) {
    var source = fns[0];

    fns[0] = function () {
      return source;
    };
  }

  if (fns.length > 1) {
    // Duplex at end: use duplex sink
    if (isDuplex(fns[fns.length - 1])) {
      fns[fns.length - 1] = fns[fns.length - 1].sink;
    }
  }

  if (fns.length > 2) {
    // Duplex in the middle, consume source with duplex sink and return duplex source
    for (var i = 1; i < fns.length - 1; i++) {
      if (isDuplex(fns[i])) {
        fns[i] = duplexPipelineFn(fns[i]);
      }
    }
  }

  return rawPipe.apply(void 0, fns);
};

module.exports = pipe;
module.exports.pipe = pipe;
module.exports.rawPipe = rawPipe;
module.exports.isIterable = isIterable;
module.exports.isDuplex = isDuplex;